import { render, staticRenderFns } from "./PropertyGroups.vue?vue&type=template&id=7b0f1fe6"
import script from "./PropertyGroups.vue?vue&type=script&lang=js"
export * from "./PropertyGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports